import { getFile } from '@debbie/cortex/dist/files.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Loading from './Loading.js';
import Error from './Messages/Error.js';
const ObjectComp = (props) => {
    const lang = useSelector((s) => s.lang);
    const [file, setFile] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        const url = props.url;
        if (url) {
            getFile(url)
                .then((res) => {
                if (url === props.url) {
                    setFile(res);
                }
            })
                .catch((err) => {
                console.error(err);
                if (url === props.url) {
                    setError(lang.interactions.downloadFailed);
                }
            });
        }
    }, [props.url]);
    return (React.createElement(React.Fragment, null, file ? (React.createElement("object", { style: props.style, type: "application/pdf", data: file + '#navpanes=0' })) : error ? (React.createElement("div", { style: props.style },
        React.createElement(Error, { messages: [error] }))) : (React.createElement(Loading, { style: { ...(props.style ?? {}), width: '100%', height: '40px' } }))));
};
export default ObjectComp;
//# sourceMappingURL=ObjectComp.js.map